import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  TextField,
  Typography,
} from "@material-ui/core";

import LetterX from "../../../autorizaciones/UI/LetterX";

import { deletePracticaDiscapacidad, setearValorEnPracticaDiscapacidad } from "../../../../actions/discapacidad/discapacidadActions";

const IntegracionPractica = (props) => {
  const dispatch = useDispatch();

  const [cantidad, setCantidad] = useState(
    props.practica ? props.practica?.cant : 1
  );

  const disabledProp = props.disabled;

  useEffect(() => {
    setCantidad(props.practica ? props.practica?.cant : 1)
  }, [props.practica])

  return (
    <div style={{ marginBottom: "2.8rem", marginRight: 40 }}>
      <div
        style={{
          padding: "1rem",
          marginTop: "1.0rem",
          marginBottom: props.desdeAuditar ? 0 : "0.5rem",
          marginRight: "1rem",
          marginLeft: "1rem",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {!disabledProp && (
          <LetterX
            deleteFunction={() => {
              dispatch(deletePracticaDiscapacidad(props.practica?.idCodNom));
              if(!!props.auditoria && !!props.setHasChangesPractica)
                props.setHasChangesPractica();
            }}
            styles={{
              cursor: "pointer",
              position: "relative",
              top: "0.25rem",
              marginRight: "0.5rem",
            }}
          />
        )}
        <Typography variant="h6" style={{ flexGrow: 1, fontSize: "1.1rem", marginRight: 20, width: "90%" }}>
          {`${props.practica?.practica?.codIntegrador} / ${props.practica?.practica?.codNom} - ${props.practica?.practica?.modulo}`}
        </Typography>
        <TextField
          style={{
            width: "10%",
            position: "relative",
            bottom: "1.2rem",
            marginTop: 20,
            minWidth: 65,
          }}
          variant="outlined"
          type="number"
          label="Cantidad"
          value={cantidad}
          disabled={disabledProp}
          onChange={(e) => {
            if(e.target.value > 0){
              setCantidad(e.target.value);
              dispatch(
                setearValorEnPracticaDiscapacidad(
                  props.practica?.idCodNom,
                  "cant",
                  Number(e.target.value)
                )
              );
              if(!!props.auditoria && !!props.setHasChangesPractica)
                props.setHasChangesPractica();
            }
          }}
          error={props.cantidad <= 0}
          helperText={props.cantidad <= 0 && "Debe ser mayor a 0."}
        />
      </div>      
    </div>
  );
};

export default IntegracionPractica;
